import React, { useEffect, useState } from "react";
import LoadingIcon from "./LoadingIcon";
import { useAuth } from "./../util/auth";
import { useRouter } from "./../util/router";
import { redirectToBilling } from "./../util/stripe";

function SettingsBilling(props) {
  const router = useRouter();
  const auth = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // T-051: gate on `canManageBilling`, not `planIsActive`. A `past_due` subscription
    // is exactly the case where the customer needs the billing portal, and
    // `planIsActive` is false for it — so this branch used to send the people with a
    // billing problem away from the page that fixes billing problems.
    if (auth.user.canManageBilling) {
      // If the user has a subscription that can be managed then
      // take them to Stripe billing
      redirectToBilling().catch((error) => {
        console.error("Failed to create Stripe billing session:", error);
        setLoading(false);
        props.onStatus({
          type: "error",
          message: error.message,
        });
      });
    } else {
      // Otherwise go to packages so they can
      // purchase a plan
      router.replace("/all");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && (
        <div className="mx-auto w-7">
          <LoadingIcon />
        </div>
      )}
    </>
  );
}

export default SettingsBilling;
